export const HOST_API_KEY = '';

export const RECAPTCHA_PUBLIC_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';